import { Button, Modal } from "react-bootstrap";

const CheckAlreadyRequestedModal = ({ show, hideModal }) => {
  return (
    <Modal show={show} onHide={hideModal} centered>
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Check Already Requested
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-l-5 p-t-5 p-0">
        <p
          style={{
            fontSize: "14px",
            fontWeight: "600",
            color: "var(--primary-25)",
            textAlign: "center",
          }}
        >
          A check has been requested, issued, or completed. Please delete the check request before
          editing this row.
        </p>
      </Modal.Body>
      <Modal.Footer
        className="p-0 mt-0 d-flex w-100 justify-content-between padding-outside-btn-new-provider"
        style={{ borderTop: "none" }}
      >
        <div className="d-flex align-items-center w-100 justify-content-center">
          <Button
            className="button-padding-footer-new-provider p-2 d-flex align-items-center justify-content-center "
            variant="secondary"
            onClick={hideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckAlreadyRequestedModal;
